<template>
  <b-modal
    ref="modal"
    hide-header
    hide-footer
    centered
    :no-close-on-backdrop="!dismissible"
    :no-close-on-esc="!dismissible"
  >
    <div class="confirm-warning">
      <div class="d-flex align-items-center mb-5">
        <div
          class="confirm-warning__icon"
          :class="`confirm-warning__icon--${variant}`"
        >
          <i :class="[icon, `text-${variant}`]"></i>
        </div>
        <h3 class="font-weight-bolder text-dark mb-0 ml-4">{{ title }}</h3>
      </div>

      <div v-if="$slots.default || message" class="mb-4">
        <slot>{{ message }}</slot>
      </div>

      <div v-if="notes.length" class="confirm-warning__notes mb-4">
        <div
          v-for="(note, index) in notes"
          :key="index"
          class="d-flex align-items-start"
          :class="{ 'mb-3': index < notes.length - 1 }"
        >
          <span class="confirm-warning__step">{{ index + 1 }}</span>
          <span>
            <slot name="note" :note="note" :index="index">{{ note }}</slot>
          </span>
        </div>
      </div>

      <p v-if="question" class="mb-0">{{ question }}</p>

      <div class="confirm-warning__footer d-flex justify-content-end">
        <b-button
          variant="secondary"
          class="font-weight-bold mr-3"
          @click="onCancel()"
          >{{ cancelText }}</b-button
        >
        <b-button
          :variant="variant"
          class="font-weight-bold"
          @click="onConfirm()"
          >{{ confirmText }}</b-button
        >
      </div>
    </div>
  </b-modal>
</template>

<script>
// Modal cảnh báo trước khi thực hiện hành động, dạng: icon + tiêu đề, mô tả, danh sách
// hệ quả đánh số, câu hỏi xác nhận. Khác ConfirmActionModal (SweetAlert2, chỉ 1 dòng text)
// ở chỗ trình bày được nhiều ý có định dạng.
// Chỉ emit @confirm / @cancel, không tự xử lý hành động. Cha gọi qua ref: this.$refs['...'].show().
// Nội dung có in đậm thì dùng slot mặc định (mô tả) và scoped slot `note` (từng dòng hệ quả).
export default {
  name: 'ConfirmWarningModal',
  props: {
    title: {
      type: String,
      default: 'Xác nhận',
    },
    message: {
      type: String,
      default: '',
    },
    // Mỗi phần tử là 1 dòng hệ quả; render text thô, hoặc qua slot `note` nếu cần định dạng.
    notes: {
      type: Array,
      default: () => [],
    },
    question: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: 'Xác nhận',
    },
    cancelText: {
      type: String,
      default: 'Hủy',
    },
    // Màu bootstrap của icon và nút xác nhận: danger | warning | primary.
    variant: {
      type: String,
      default: 'danger',
    },
    icon: {
      type: String,
      default: 'flaticon-exclamation-1',
    },
    // Cho phép đóng bằng backdrop/esc.
    dismissible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onConfirm() {
      this.hide();
      this.$emit('confirm');
    },
    onCancel() {
      this.hide();
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.confirm-warning {
  padding: 0.5rem;
  font-size: 1.1rem;
  color: #3f4254;
}
.confirm-warning__icon {
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-warning__icon i {
  font-size: 1.8rem;
}
.confirm-warning__icon--danger {
  background: #ffe2e5;
}
.confirm-warning__icon--warning {
  background: #fff4de;
}
.confirm-warning__icon--primary {
  background: #e1f0ff;
}
.confirm-warning__notes {
  background: #f3f6f9;
  border-radius: 0.42rem;
  padding: 1rem 1.25rem;
}
.confirm-warning__step {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-right: 0.75rem;
  border-radius: 50%;
  background: #e4e6ef;
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
.confirm-warning__footer {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid #ebedf3;
}
</style>
